import {
  renderDropdownWithoutLabel,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';

const EmbryologyHormonalPregDetails = ({
  embryoTransferDetails,
  handleInputChange,
}) => {
  return (
    <div className="card">
      <h3 style={{ textAlign: 'center' }}>Hormonal Pregnancy Details</h3>

      <div className="body" style={{ display: 'flex', gap: '10px' }}>
        <table
          cellPadding={'20px'}
          style={{ flexGrow: 1, padding: '0px 10px' }}
        >
          <tbody>
            <tr>
              <td>b-Hcg positive</td>
              <td>
                {renderDropdownWithoutLabel(
                  'bhcgPositive',
                  embryoTransferDetails.bhcgPositive,
                  [' ', 'Yes', 'No'],
                  handleInputChange,
                )}
              </td>
            </tr>
            {embryoTransferDetails.bhcgPositive == 'Yes' && (
              <tr>
                <td>1st b-HCG value</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'bhcgValue1',
                    embryoTransferDetails.bhcgValue1,
                    handleInputChange,
                  )}
                </td>
                <td>2nd b-HCG value</td>
                <td>
                  {renderInputFieldWithoutLabel(
                    'bhcgValue2',
                    embryoTransferDetails.bhcgValue2,
                    handleInputChange,
                  )}
                </td>
                <td>Biochemical Pregnancy (0/1)</td>
                <td>
                  {renderDropdownWithoutLabel(
                    'biochemicalPregnany',
                    embryoTransferDetails.biochemicalPregnany,
                    [' ', '0', '1'],
                    handleInputChange,
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default EmbryologyHormonalPregDetails;
